<template>
    <a-modal :visible="isModalOpen" @update:visible="val => isModalOpen = val" @ok="() => submit()" @cancel="closeModal"
        ok-text="Submit" cancel-text="Batal" :confirm-loading="isSubmitting" class="modal-saran-masukan">
        <div class="w-full flex flex-col gap-2">
            <div class="w-full flex flex-col gap-px px-1">
                <h4 class="text-center! text-white text-xl!">Ubah Kata Sandi</h4>
            </div>
            <div class="flex flex-col gap-1 relative">
                <input :type="passVisible.old_pass ? 'text' : 'password'" id="old_pass" name="old_pass"
                    placeholder="Kata Sandi Lama" class="form-control w-full text-xs!" v-model="formRef.old_pass"
                    required />
                <EyeIcon v-if="!passVisible.old_pass" @click="updateVisibility('old_pass')"
                    class="cursor-pointer w-5 h-5 absolute right-2 top-1.5 text-gray-400" />
                <EyeOffIcon v-else @click="updateVisibility('old_pass')"
                    class="cursor-pointer w-5 h-5 absolute right-2 top-1.5 text-gray-400" />
            </div>

            <div class="flex flex-col gap-1 relative">
                <input :type="passVisible.new_pass ? 'text' : 'password'" id="new_pass" name="new_pass"
                    placeholder="Kata Sandi Baru" class="form-control w-full text-xs!" v-model="formRef.new_pass"
                    required />
                <EyeIcon v-if="!passVisible.new_pass" @click="updateVisibility('new_pass')"
                    class="cursor-pointer w-5 h-5 absolute right-2 top-1.5 text-gray-400" />
                <EyeOffIcon v-else @click="updateVisibility('new_pass')"
                    class="cursor-pointer w-5 h-5 absolute right-2 top-1.5 text-gray-400" />
            </div>

            <div class="flex flex-col gap-1 relative">
                <input :type="passVisible.retype_pass ? 'text' : 'password'" id="retype_pass" name="retype_pass"
                    placeholder="Konfirmasi Kata Sandi Baru" class="form-control w-full text-xs!"
                    v-model="formRef.retype_pass" required />
                <EyeIcon v-if="!passVisible.retype_pass" @click="updateVisibility('retype_pass')"
                    class="cursor-pointer w-5 h-5 absolute right-2 top-1.5 text-gray-400" />
                <EyeOffIcon v-else @click="updateVisibility('retype_pass')"
                    class="cursor-pointer w-5 h-5 absolute right-2 top-1.5 text-gray-400" />
            </div>
            <div class="mx-auto mt-2">
                <Recaptcha :siteKey="siteKey" @verified="onVerify" @expired="onExpired" />
            </div>
        </div>
    </a-modal>
</template>

<script>
import { Modal } from 'ant-design-vue';
import { ref } from 'vue';
import Swal from 'sweetalert2'
import Recaptcha from "@/component/utils/Recaptcha.vue";
import { EyeIcon, EyeOffIcon } from "lucide-vue-next";
import { mapActions, mapState } from 'vuex';

export default {
    props: {
        isModalOpen: {
            type: Boolean,
            default: false,
        },
    },
    setup() {
        const passVisible = ref({
            old_pass: false,
            new_pass: false,
            retype_pass: false,
        });
        const formRef = ref({
            old_pass: null,
            new_pass: null,
            retype_pass: null,
        });
        const isSubmitting = ref(false)
        const state = ref({
            isVerified: false,
            token: null,
        })
        const siteKey = process.env.VUE_APP_SITE_KEY;

        return {
            passVisible,
            formRef,
            isSubmitting,
            state,
            siteKey,
        }
    },
    components: {
        AModal: Modal,
        Recaptcha,
        EyeIcon,
        EyeOffIcon,
    },
    methods: {
        ...mapActions('homePage', ['sendSaran', 'checkRecaptcha']),
        ...mapActions('users', ['updatePassword']),
        openModal() {
            this.$emit('onModalOpen')
        },
        async submit() {
            try {
                this.isSubmitting = true
                if (!this.formRef.old_pass || !this.formRef.new_pass || !this.formRef.retype_pass) {
                    Swal.fire({
                        title: 'Error',
                        text: 'Semua kolom harus diisi',
                        icon: 'error',
                    })
                    return
                }

                if (!this.state.token) {
                    Swal.fire({
                        title: 'Error',
                        text: 'Harap selesaikan recaptcha',
                        icon: 'error',
                    })
                    return
                }

                const captchaResponse = await this.checkRecaptcha({
                    token: this.state.token,
                });
                if (captchaResponse.valid) {
                    const cmsUrl = process.env.VUE_APP_CMS_URL;
                    const res = await this.updatePassword({
                        current_password: this.formRef.old_pass,
                        new_password: this.formRef.new_pass,
                        confirm_password: this.formRef.retype_pass,
                    })
                    if (res.data.success) {
                        Swal.fire({
                            title: 'Sukses',
                            text: res.data.message,
                            icon: 'success'
                        }).then(() => {
                            localStorage.removeItem('token')
                            localStorage.removeItem('auth_token')
                            localStorage.removeItem('users-info')
                            window.open(`${cmsUrl}/adminpanel/#/login`, '_self')
                            sessionStorage.clear()
                            this.closeModal()
                        })
                    } else {
                        if (window?.grecaptcha) {
                            window.grecaptcha.reset()
                        }
                    }

                }
            } catch (err) {
                if (err?.response?.status === 401) {
                    Swal.fire({
                        title: 'Error',
                        text: 'Terjadi kesalahan, silakan coba kembali',
                        icon: 'error'
                    }).then(() => {
                        // router.push('/auth/login')
                        this.closeModal()
                    })
                }

                if (err?.response?.data?.errors) {
                    const errorMessages = Object.values(err?.response?.data?.errors).join(', ')

                    Swal.fire({
                        title: 'Error',
                        text: errorMessages,
                        icon: 'error',
                    })
                } else if (err?.response?.data?.message) {
                    Swal.fire({
                        title: 'Error',
                        text: err?.response?.data?.message,
                        icon: 'error',
                    })
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: 'Terjadi kesalahan, silakan coba kembali',
                        icon: 'error',
                    })
                }
            } finally {
                this.isSubmitting = false
                if (window?.grecaptcha) {
                    window.grecaptcha.reset()
                }
                this.state.token = null
                this.state.isVerified = false
            }
        },
        closeModal() {
            this.formRef.old_pass = null;
            this.formRef.new_pass = null;
            this.formRef.retype_pass = null;
            this.$emit('onModalCloses')
        },
        onVerify(token) {
            this.state.isVerified = true;
            this.state.token = token;
        },
        onExpired() {
            this.state.isVerified = false;
            this.state.token = "";
        },
        updateVisibility(field) {
            this.passVisible[field] = !this.passVisible[field];
        },
    },
    computed: {
        ...mapState('homePage', {
            dataUser: (state) => state.user,
        })
    },
}
</script>

<style scoped>
.color-theme {
    background-color: #CAF0F8;
    color: #023e8a;
}
</style>